import styled from "styled-components";

const TitleTypography = styled.div`
  font-size: 1.25rem;
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 16px;
`;

const TitleTypographyTabs = styled.div`
  font-size: 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  margin-bottom: 8px;
  margin-top: 8px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export { TitleTypography, TitleTypographyTabs };